module.exports = __webpack_public_path__ + "static/media/bfile-mfg.176cbc18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-mfg.svg
// module id = 563
// module chunks = 0